import getAnyOrNull from 'utils/accessors/getAnyOrNull.util';
import nullBind from 'utils/functions/nullBind.util';

// These are the most simple getters,
// they will navigate the path, return the data found
// or default to null for null/undefined

export const selectOnboarding = nullBind(getAnyOrNull, 'onboarding');

export const selectOnboardingIsPosting = nullBind(getAnyOrNull, 'onboarding.salonSetup.isPosting');
export const selectOnboardingCompleted = nullBind(getAnyOrNull, 'onboarding.salonSetup.quickSalonCreationCompleted');
export const selectOnboardingError = nullBind(getAnyOrNull, 'onboarding.salonSetup.errorMessage');
export const selectOnboardingSaved = nullBind(getAnyOrNull, 'onboarding.salonSetup.saved');
export const selectOnboardingResponse = nullBind(getAnyOrNull, 'onboarding.salonSetup.response');

export const selectOnboardingRoles = nullBind(getAnyOrNull, 'onboarding.roles');
export const selectOnboardingServices = nullBind(getAnyOrNull, 'onboarding.services');
export const selectOnboardingServicesCategories = nullBind(getAnyOrNull, 'onboarding.services.categories');
export const selectOnboardingStylists = nullBind(getAnyOrNull, 'onboarding.stylists');
